import * as dotenv from 'dotenv';

dotenv.config({ path: './.env' });

export const isProd = process.env.NODE_ENV === 'production';

// This port should match the port being used in app flow client project
const WIZARD_CLIENT_PORT = process.env.WIZARD_CLIENT_PORT || 3000;

export const IMAGE_PATH = isProd
  ? 'https://images.expeditiondata.com'
  : 'https://images-dev.thehiringengine.com';

export const WIZARD_DOMAIN = isProd
  ? 'https://apply.teamengine.io'
  : `https://local.apply.expeditiondata.com:${WIZARD_CLIENT_PORT}`;

export const CAREERS_DOMAIN = isProd ? 'https://jobs.teamengine.io' : 'http://localhost:8080';
